/*************************************
 *
 * 路由权限控制
 * Author:smallsix@66629
 *
 *************************************/

import { saveLocalHref } from './webCache'
import { wechatAuth } from './wechatAuth'
import { isWebView, isWechat } from './customUtils'

export default function permission (router) {
  router.beforeEach((to, from, next) => {
    let toPath = to.fullPath
    if (!toPath.includes('bindMobile')) {
      saveLocalHref(toPath)
    }
    // 非微信浏览器判断当前页面是否需要登录
    if (!isWechat()) { // 非微信浏览器
      if (to.meta.isWechat && !isWebView()) {
        // next()
        wechatAuth(to, next)
      } else {
        next()
      }
    } else { // 是微信浏览器
      wechatAuth(to, next)
    }
  })
}



// WEBPACK FOOTER //
// ./src/utils/permission.js